import dayjs, { Dayjs } from 'dayjs';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { InputError, InputWrapper } from 'src/components';
import { TextInputExtended } from './TextInputExtended';
import { useOneFormContext } from 'src/feature-app/OneForm';
import { store } from 'src/feature-app';
import { OneFormState } from 'src/types';
import styled from 'styled-components';

const Wrapper = styled.div`
	input[type='date'] {
		appearance: none; /* Oculta el icono en algunos navegadores */
		-webkit-appearance: none;
		-moz-appearance: none;
	}
	input[type='date']::-webkit-calendar-picker-indicator {
		display: none; /* Para Chrome, Safari, Edge */
	}

	input[type='date']::-moz-calendar-picker-indicator {
		display: none; /* Para Firefox */
	}
	input[type='date']::-webkit-calendar-picker-indicator {
		opacity: 0;
		pointer-events: none;
	}
`;
interface DateProps {
	name?: string;
	value?: string;
	label?: string;
	required?: boolean;
	minDate?: Dayjs;
	maxDate?: Dayjs;
	paddingTop?: string;
}

export function Date(props: DateProps) {
	const { register, errors } = useFormContext();
	const { name, label, required, value, minDate, maxDate, paddingTop } =
		props;
	const { formInfo }: OneFormState = store.getState();
	const [inputValue, setInputValue] = useState(value || '');
	const [inputError, setInputError] = useState(false);
	const { error, setError } = useOneFormContext();
	const dispatch = useDispatch();
	const today = dayjs();

	const defaultMax = today.subtract(18, 'year');
	const defaultMin = today.subtract(100, 'year');

	const theMaxDate =
		maxDate && dayjs(maxDate).isValid() ? maxDate : defaultMax;
	const theMinDate =
		minDate && dayjs(minDate).isValid() ? minDate : defaultMin;

	const handleChange = (e: any) => {
		const value = e.target.value;

		if (!isValidDate(value)) {
			setInputError(true);
			setError(true);
		} else {
			dispatch({ type: 'UPDATE_FIELDS', payload: { [name]: value } });
			//dispatch({ type: 'UPDATE_LITERAL_FIELDS_STEPS', payload: { [name]: dayjs(value, 'YYYY-MM-DD').format('DD-MM-YYYY') } });
			setInputValue(value);
			setInputError(false);
			setError(false);
		}
	};

	const isValidDate = value => {
		if (!value) {
			return false;
		} else if (theMinDate > dayjs(value) || theMaxDate < dayjs(value)) {
			return false;
		} else {
			return true;
		}
	};

	return (
		<InputWrapper
			className="date-input-wrapper"
			notALayer={formInfo.notALayer}
			paddingTop={props.paddingTop}
		>
			<Wrapper>
				<TextInputExtended
					name={name ? name : 'date'}
					label={label ? label : 'Fecha'}
					value={inputValue}
					innerRef={register({
						required: {
							value: required ? required : false,
							message: 'Requerido',
						},
						validate: value => isValidDate(value),
					})}
					type="date"
					onChange={e => handleChange(e)}
					required={required ? required : false}
				/>
				{inputError && (
					<InputError className="input-error">
						Esta fecha no es válida
					</InputError>
				)}
			</Wrapper>
		</InputWrapper>
	);
}
